import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
} from '@chakra-ui/react';
import { useCallback } from 'react';
import GlobalFormComponent from 'core/components/forms/GlobalFormComponent';
import { FormContext } from 'core/services/index';
import { useContext } from 'react';
import { useModule } from '@starberry/components';
import { useEffect } from 'react';

const FormDialog = ({
  title,
  isOpen = true,
  fields,
  onClose,
  onSubmit,
  data,
  submitLabel = 'Submit',
}) => {
  const [form, dispatch] = useContext(FormContext);

  useEffect(() => {
    if (isOpen && data) {
      dispatch({
        type: 'CHANGE_FORM_STATE',
        payload: {
          values: data,
        },
      });
    }
  }, [isOpen, dispatch, data]);

  const handleChange = useCallback(
    (id, data) => {
      dispatch({
        type: 'CHANGE_FORM_VALUE',
        payload: {
          [id]: data,
        },
      });
    },
    [dispatch]
  );

  const handleSubmit = useCallback(() => {
    if (dispatch) {
      onSubmit?.(form.values || {});
      dispatch?.({
        type: 'CHANGE_FORM_STATE',
        payload: {
          values: {},
        },
      });
    }
  }, [form, dispatch, onSubmit]);

  const PrimaryButton = useModule('PrimaryButton');
  if (!PrimaryButton) {
    return null;
  }

  return (
    <Modal
      isOpen={isOpen}
      closeOnEsc
      trapFocus
      autoFocus
      scrollBehavior="outside"
      closeOnOverlayClick
      isCentered
      onClose={() => onClose?.()}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton _focus={{ boxShadow: 'none' }} />
        <ModalBody mb="5">
          <GlobalFormComponent
            formFields={fields}
            formStateType={form?.values}
            onChange={handleChange}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default FormDialog;
